import type { ObjEntity } from "../../api/types.gen.ts";
import { t } from "../../i18n/index.ts";
import { EntityGlyph } from "../../ui/EntityGlyph.tsx";
import { MenuSelect } from "../../ui/form.tsx";

/** What an item is, picked in a field: the entities with their icons (as the selection's menu has them), then none. */
export function EntitySelect(p: { entities: readonly ObjEntity[]; value: string; onValue: (v: string) => void }) {
  return (
    <MenuSelect
      value={p.value}
      onValue={p.onValue}
      options={[
        ...p.entities.map((e) => ({ value: e.id, label: e.name, icon: <EntityGlyph icon={e.icon} empty="dot" /> })),
        { value: "", label: t("items.noEntity"), icon: <EntityGlyph icon={null} empty="none" /> },
      ]}
    />
  );
}
